export class MenuItemId {
  public id: number;
  public courses: string;
  public alergens: number[];
}
